if (!customElements.get('localization-form-select')) {
  customElements.define(
    'localization-form-select',
    class LocalizationFormSelect extends HTMLElement {
      constructor() {
        super();
        this.querySelector('select').addEventListener('change', this.onSelectChange.bind(this));
      }

      onSelectChange(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (form) form.submit();
      }
    }
  );
};